var map = {
	"./chicken/drag1.png": 5875,
	"./chicken/drag2.png": 3896,
	"./chicken/drag3.png": 2289,
	"./chicken/fall1.png": 1160,
	"./chicken/fall2.png": 5651,
	"./chicken/fall3.png": 442,
	"./chicken/fall4.png": 5109,
	"./chicken/fall5.png": 2044,
	"./chicken/happy1.png": 7217,
	"./chicken/happy2.png": 8234,
	"./chicken/happy3.png": 8995,
	"./chicken/jump1.png": 8437,
	"./chicken/jump2.png": 8062,
	"./chicken/jump3.png": 3847,
	"./chicken/jump4.png": 4232,
	"./chicken/jump5.png": 2625,
	"./chicken/msg1.png": 7278,
	"./chicken/msg2.png": 4005,
	"./chicken/msg3.png": 2380,
	"./chicken/msg4.png": 1779,
	"./chicken/sleep1.png": 6084,
	"./chicken/sleep2.png": 735,
	"./chicken/sleep3.png": 4406,
	"./chicken/sleep4.png": 4233,
	"./chicken/wake1.png": 33,
	"./chicken/wake2.png": 9866,
	"./chicken/wake3.png": 1091,
	"./chicken/wake4.png": 924,
	"./chicken/wake5.png": 6373,
	"./chicken/walk1.png": 7036,
	"./chicken/walk2.png": 5143,
	"./chicken/walk3.png": 9566,
	"./chicken/walk4.png": 7281,
	"./spinosaurus/drag1.png": 9720,
	"./spinosaurus/drag2.png": 1683,
	"./spinosaurus/drag3.png": 9770,
	"./spinosaurus/fall1.png": 9059,
	"./spinosaurus/fall2.png": 7432,
	"./spinosaurus/fall3.png": 1649,
	"./spinosaurus/fall4.png": 638,
	"./spinosaurus/fall5.png": 8951,
	"./spinosaurus/happy1.png": 7908,
	"./spinosaurus/happy2.png": 9535,
	"./spinosaurus/happy3.png": 5734,
	"./spinosaurus/jump1.png": 926,
	"./spinosaurus/jump2.png": 3349,
	"./spinosaurus/jump3.png": 5836,
	"./spinosaurus/jump4.png": 9443,
	"./spinosaurus/jump5.png": 8682,
	"./spinosaurus/msg1.png": 5931,
	"./spinosaurus/msg2.png": 4720,
	"./spinosaurus/msg3.png": 8921,
	"./spinosaurus/msg4.png": 8950,
	"./spinosaurus/sleep1.png": 3041,
	"./spinosaurus/sleep2.png": 1930,
	"./spinosaurus/sleep3.png": 6035,
	"./spinosaurus/sleep4.png": 9788,
	"./spinosaurus/wake1.png": 5530,
	"./spinosaurus/wake2.png": 4513,
	"./spinosaurus/wake3.png": 9896,
	"./spinosaurus/wake4.png": 1415,
	"./spinosaurus/wake5.png": 2046,
	"./spinosaurus/walk1.png": 5459,
	"./spinosaurus/walk2.png": 4616,
	"./spinosaurus/walk3.png": 3681,
	"./spinosaurus/walk4.png": 590,
	"./trex/drag1.png": 3713,
	"./trex/drag2.png": 5402,
	"./trex/drag3.png": 627,
	"./trex/fall1.png": 9250,
	"./trex/fall2.png": 3257,
	"./trex/fall3.png": 7504,
	"./trex/fall4.png": 3375,
	"./trex/fall5.png": 4630,
	"./trex/happy1.png": 235,
	"./trex/happy2.png": 5200,
	"./trex/happy3.png": 6377,
	"./trex/jump1.png": 9463,
	"./trex/jump2.png": 988,
	"./trex/jump3.png": 3877,
	"./trex/jump4.png": 9578,
	"./trex/jump5.png": 1155,
	"./trex/msg1.png": 4768,
	"./trex/msg2.png": 9803,
	"./trex/msg3.png": 802,
	"./trex/msg4.png": 2365,
	"./trex/sleep1.png": 3298,
	"./trex/sleep2.png": 7305,
	"./trex/sleep3.png": 2819,
	"./trex/sleep4.png": 7423,
	"./trex/wake1.png": 1655,
	"./trex/wake2.png": 3548,
	"./trex/wake3.png": 6437,
	"./trex/wake4.png": 3210,
	"./trex/wake5.png": 8419,
	"./trex/walk1.png": 7754,
	"./trex/walk2.png": 6737,
	"./trex/walk3.png": 2120,
	"./trex/walk4.png": 3639,
	"./triceratops/drag1.png": 1202,
	"./triceratops/drag2.png": 6345,
	"./triceratops/drag3.png": 1520,
	"./triceratops/fall1.png": 7873,
	"./triceratops/fall2.png": 7290,
	"./triceratops/fall3.png": 2499,
	"./triceratops/fall4.png": 1276,
	"./triceratops/fall5.png": 4165,
	"./triceratops/happy1.png": 5594,
	"./triceratops/happy2.png": 4577,
	"./triceratops/happy3.png": 1864,
	"./triceratops/jump1.png": 1076,
	"./triceratops/jump2.png": 4639,
	"./triceratops/jump3.png": 6550,
	"./triceratops/jump4.png": 809,
	"./triceratops/jump5.png": 5984,
	"./triceratops/msg1.png": 1265,
	"./triceratops/msg2.png": 682,
	"./triceratops/msg3.png": 5891,
	"./triceratops/msg4.png": 1020,
	"./triceratops/sleep1.png": 6243,
	"./triceratops/sleep2.png": 4264,
	"./triceratops/sleep3.png": 6305,
	"./triceratops/sleep4.png": 8094,
	"./triceratops/wake1.png": 1404,
	"./triceratops/wake2.png": 135,
	"./triceratops/wake3.png": 142,
	"./triceratops/wake4.png": 3233,
	"./triceratops/wake5.png": 520,
	"./triceratops/walk1.png": 733,
	"./triceratops/walk2.png": 5318,
	"./triceratops/walk3.png": 9119,
	"./triceratops/walk4.png": 1088,
	"./velociraptor/drag1.png": 1848,
	"./velociraptor/drag2.png": 8707,
	"./velociraptor/drag3.png": 4602,
	"./velociraptor/fall1.png": 3331,
	"./velociraptor/fall2.png": 2488,
	"./velociraptor/fall3.png": 7105,
	"./velociraptor/fall4.png": 990,
	"./velociraptor/fall5.png": 4007,
	"./velociraptor/happy1.png": 3412,
	"./velociraptor/happy2.png": 5871,
	"./velociraptor/happy3.png": 7126,
	"./velociraptor/jump1.png": 798,
	"./velociraptor/jump2.png": 2901,
	"./velociraptor/jump3.png": 12,
	"./velociraptor/jump4.png": 179,
	"./velociraptor/jump5.png": 8602,
	"./velociraptor/msg1.png": 4187,
	"./velociraptor/msg2.png": 8784,
	"./velociraptor/msg3.png": 4537,
	"./velociraptor/msg4.png": 9558,
	"./velociraptor/sleep1.png": 9009,
	"./velociraptor/sleep2.png": 26,
	"./velociraptor/sleep3.png": 8883,
	"./velociraptor/sleep4.png": 5276,
	"./velociraptor/wake1.png": 1466,
	"./velociraptor/wake2.png": 1633,
	"./velociraptor/wake3.png": 3768,
	"./velociraptor/wake4.png": 8935,
	"./velociraptor/wake5.png": 622,
	"./velociraptor/walk1.png": 8467,
	"./velociraptor/walk2.png": 3192,
	"./velociraptor/walk3.png": 1057,
	"./velociraptor/walk4.png": 46
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5707;